var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd-input',{attrs:{"title":_vm.title,"name":_vm.name,"data-dusk":_vm.dataDusk,"rules":_vm.rules,"placeholder":"1234 AB","maxlength":7},model:{value:(_vm.postalCode),callback:function ($$v) {_vm.postalCode=$$v},expression:"postalCode"}})}
var staticRenderFns = []

export { render, staticRenderFns }